import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import 'primeicons/primeicons.css';
import './PatientMenu.css';
var defaultimage = require('../../assets/img/images.png');

const PatientMenu = () => {
  const name = window.sessionStorage.getItem('username');
   const photo = window.sessionStorage.getItem('photo');
  const items = [
    {
      label: 'Dashboard',
      icon: 'pi pi-gauge',
      url: '/medi/patientdashboard',
    },
    {
      label: 'Cases',
      icon: 'pi pi-list',
      url: '/medi/patientcases',
    },
    {
      label: 'Family',
      icon: 'pi pi-users',
      url: '/medi/patientfamily',
    },
    {
      label: 'Appointments',
      icon: 'pi pi-calendar',
      url: '/medi/patientappointments',
    },
    {
      label: 'Reports',
      icon: 'pi pi-file',
      url: '/medi/patreports',
    },
    {
      label: 'Applications',
      icon: 'pi pi-briefcase',
      url: '/medi/patientapplications',
    },
    {
      label: 'Activities',
      icon: 'pi pi-bars',
      url: '/medi/patientactivities',
    },
  ];
  const handleItemClick = (event: { item: { url: string } }) => { if (event.item.url) { window.location.href = event.item.url; } };

  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="menu-container" style={{margin:'0px 10px'}}>
          <PanelMenu model={items} style={{backgroundColor:'#fff'}} />
        </div>
      </div>
    </aside>
  );
};

export default PatientMenu;
